import React from 'react';

function getStatusColorClass(nome) {
    if (!nome || typeof nome !== 'string') return 'chamado-status-cinza';
    const n = nome.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (n.includes('ABERTO')) return 'chamado-status-cinza';
    if (n.includes('DESENVOLVIMENTO') || n.includes('ATENDIMENTO') || n.includes('ANALISE') || n.includes('TESTE')) return 'chamado-status-azul';
    if (n.includes('PAUSAD')) return 'chamado-status-laranja';
    if (n.includes('CONCLUID')) return 'chamado-status-verde';
    if (n.includes('BLOQUEAD')) return 'chamado-status-vermelho';
    return 'chamado-status-cinza';
}

function ChamadoStatusCard({ statusAtual, statusParaSelect, getNomeStatus, onChange, readOnly, statusNome: statusNomeProp }) {
    const statusNome = statusNomeProp != null && statusNomeProp !== '' ? String(statusNomeProp) : (getNomeStatus ? getNomeStatus(statusAtual) : (typeof statusAtual === 'string' ? statusAtual : ''));
    const colorClass = getStatusColorClass(statusNome);

    return (
        <div className="chamado-sidebar-card chamado-status-card">
            <h4 className="chamado-sidebar-card-titulo">Status</h4>
            <div className="chamado-status-badge-wrap">
                {statusNome && <span className={`chamado-badge-status ${colorClass}`}>{statusNome}</span>}
            </div>
            {!readOnly && (
                <select
                    className="chamado-status-select"
                    value={statusAtual ?? ''}
                    onChange={(e) => onChange(e.target.value)}
                    aria-label="Alterar status"
                >
                    {statusParaSelect.length === 0 ? (
                        <option value={statusAtual ?? ''}>{statusNome || '—'}</option>
                    ) : (
                        statusParaSelect.map((s) => (
                            <option key={s.id} value={s.codigo_legado}>{s.nome}</option>
                        ))
                    )}
                </select>
            )}
        </div>
    );
}

export default ChamadoStatusCard;
